import React from 'react';

const ProcessingToastContent = () => (
  <div>
    <h6 className="text-bold mb-xxxs">We’re generating your export</h6>
    <p>We’ll let you know when your export is ready for download.</p>
  </div>
);

export default ProcessingToastContent;
